import './timesheet-warning-popup.css'
const TimesheetWarningPopup = ({warningText}) => {
    return (
        <div className='timesheet-warning-popup'>
            <div>
                <div className='timesheet-warning-popup__title'>Timesheet Issues:</div>
                {warningText.map(({message, index}) => <li key={index} className="timesheet-warning-text">{message}</li>)}
            </div>
        </div>
    )
}
export default TimesheetWarningPopup